<template>
  <div>
    <div class="gray-bg">
      <main-header/>
    </div>
    <div v-if="isLoaded">
      <div v-if="moreProducts.length === 0">
        <v-alert
            text
            type="error"
        >
          محصولی یافت نشد
        </v-alert>
      </div>
      <more-products v-else :productsArray="moreProducts"/>
    </div>
    <Footer/>
    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MainHeader from "./mainHeader";

let _this = null;
import MoreProducts from "./moreProducts";
import goTo from 'vuetify/lib/services/goto'
import Footer from "./Footer";


export default {
  name: "categoryMoreProducts",
  metaInfo() {
    return {
      title: window.projectName + this.$route.name,
      meta: [
        { //  set meta
          name: 'keywords',
          content: this.$keywords
        },
        { //  set meta
          name: 'description',
          content: this.$description
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: this.$seoUrl + this.$route.path
        }
      ]
    }
  },
  components: {Footer, MainHeader, MoreProducts},
  data: () => ({
    moreProducts: [],
    isLoaded: false,
    showLoaderDialog: false,
  }),
  mounted() {
    _this = this;
    this.getData();
  },
  methods: {
    getData() {
      this.showLoaderDialog = true
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let id = this.$route.query.CategoryID;
      console.log(id)

      var urlencoded = new URLSearchParams();
      urlencoded.append("CategoryID", id);

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      fetch(this.$baseUrl + "/SearchEngine/ShowProductByCategoryID", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            _this.moreProducts = json
            console.log(json)
            _this.isLoaded = true;
            this.showLoaderDialog = false
            goTo(0);
          })
          .catch(error => console.log('error', error));
    }
  },
  watch: {
    '$route.query.CategoryID'() {
      this.getData();
    }
  },
}
</script>

<style scoped>

</style>
